export default __webpack_public_path__ + "static/SC_Step_2-4f60f76be0c97d5a6ce3c0551a3f3dee.svg";